import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalAnularAusenciaService {
  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

  constructor(private http: HttpClient) { }

  /**
   * Método encargado de anular una ausencia
   * @param request
   * @returns
   */
  anularAusencia(request: any): Observable<any> {
    request = this.loadSessionFields(request);
    return this.http.post<any>(this.buildUrlApi('estudios/anularAusente'), request);
  }

  /**
   * Método encargado de construir la URL del end-point
   * @param method
   * @returns
   */
  buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  /**
   * Método encargado de agregar a los request los campos comunes correspondientes al usuario logueado
   * @param request
   * @returns
   */
  private loadSessionFields(request: any): any {
    request.modelId = this.currentUser.modelId;
    request.userId = this.currentUser.userId;
    request.prestadorCod = this.currentUser.prestadorCod;
    return request;
  }
} 